<klt-section title="Portfolio composition">
  <div class="graph-box">
    <klt-graph
      [loading]="loading"
      [options]="options"
      [titles]="titles"
      (filter)="runFilter($event)"
    >
    </klt-graph>
  </div>
</klt-section>
